export enum SignupEvent {
    Submit = 'Signup Submit',
    Invite = 'Signup Invite',
    Registering = 'Signup Registering',
    Complete = 'Signup Complete',
}
